import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './testimonials.css'

const testimonials = [
  {
    title: 'JEE Made Easy!',
    content: 'The in-depth video lectures and practice tests made tough concepts so simple. Best decision ever!',
    name: 'Krishna Vamsy',
    rating: 5,
    image: '/images/students/krishna.jpg',
  },
  {
    title: 'Cleared NEET with Confidence!',
    content: 'The structured lessons and doubt-solving sessions helped me boost my confidence. Highly recommended!',
    name: 'Gauri Bhandari ',
    rating: 5,
    image: '/images/students/gauri.jpg',
  },
  {
    title: 'Seamless and Supportive Learning Journey',
    content:
      'The interactive quizzes and AI-driven study plans kept me on track. Loved the whole experience! The interactive quizzes and AI-driven study plans kept me on track. Loved the whole experience.',
    name: 'Salman Mohammad Nasmi',
    rating: 4,
    image: '/images/students/salman.jpg',
  },
  {
    title: 'Helped Me Score 95% in Boards!',
    content:
      'The clear explanations and revision notes were game-changers for my board exams! The clear explanations and revision notes were game-changers for my board exams!',
    name: 'Shani Yadav',
    rating: 5,
    image: '/images/students/ritesh.jpg',
  },
  {
    title: 'Engaging & Effective!',
    content: 'The course was well-structured, and the live classes felt like a real classroom. Highly engaging!',
    name: 'Rahul Solanki',
    rating: 4,
    image: '/images/students/rahul.jpg',
  },
  {
    title: 'Best Learning Experience!',
    content:
      'From start to finish, the learning journey with this institute has been seamless. The user interface is intuitive, the mentors are supportive, and there"s always someone to help when you feel stuck. Highly recommend!',
    name: 'Krutika Shetty',
    rating: 4,
    image: '/images/students/krutika.jpg',
  },
];

const StarRating = ({ count }) => (
  <div>
    {[...Array(count)].map((_, i) => (
      <span key={i} className="text-warning">&#9733;</span>
    ))}
  </div>
);

const TestimonialCard = ({ testimonial }) => (
  <div className="col">
    <div className="card shadow-sm custom-shadow rounded-4 p-3">
      <h5 className="fw-bold">{testimonial.title}</h5>
      <p>{testimonial.content}</p>
      <div className="d-flex align-items-center mt-3">
        <img src={testimonial.image} alt="user" className="rounded-circle me-2" width="40" height="40" />
        <div>
          <div className="fw-bold text-warning">{testimonial.name}</div>
          <StarRating count={testimonial.rating} />
        </div>
      </div>
    </div>
  </div>
);

const TestimonialsGrid = () => (
  <>
      {testimonials.map((t, index) => (
        <TestimonialCard key={index} testimonial={t} />
      ))}
  </>
);

export default TestimonialsGrid;
